import '../../style/index.less';
import './index.less';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@3.9.2@antd/es/icon/style/index.js
// module id = jeyW
// module chunks = 0 2 3 4 5 6 9 10 11 12 13 14 18 19 22 32 34 35 36 37 38 39 40